import React from "react";
import ReactDOM from "react-dom";
import CryptoJS from 'crypto-js'
import Lisenced from "./Lisenced";
import { IonPage, IonButton, IonContent, IonRow, IonCol, IonCard } from "@ionic/react";
import { toastController } from "@ionic/core";
import App from "../../App";
import { getConfig } from "../../resources/configSettings";
import ConfigContextProvider from "../../contexts/ConfigContext";
import AuthContextProvider from "../../contexts/AuthContext";

let config = getConfig();

function isExpired() {
    if (config && config.expiryDate) {
        let currentTime = Date.now();
        // console.log((config.expiryDate > currentTime && currentTime > config.registryDate));

        if (config.expiryDate > currentTime && currentTime > config.registryDate) {
            let timeLeft = (config.expiryDate - currentTime) / (60000 * 60 * 24);
            // console.log(timeLeft);
            if (timeLeft < 10)
                toastController.create({
                    color: 'dark',
                    duration: 60000 / 2,
                    message: `App will be Expire in ${timeLeft.toFixed(0)} days.`,
                    showCloseButton: false,
                    position: 'top',
                    closeButtonText: "Close"

                }).then(toast => {
                    toast.present();
                });
            return false;

        } else {
            console.log("App got Expired ");
            return true;
        }
    }
}

/** Demo Set */
const Demo = () => {
    let key = localStorage.getItem("netsession");
    let ip = localStorage.getItem("ipno");
    let n = localStorage.getItem("name");

    let hash = CryptoJS.SHA1(ip + n).toString();

    // set  key
    localStorage.setItem("netsession", hash);

    //demo page
    const contactUs = (isExpired()) ? (
        Lisenced()
    ) : ('')

    const Apps = (
        <ConfigContextProvider>
            <AuthContextProvider>
                <App />
            </AuthContextProvider>
        </ConfigContextProvider>
    )

    if (ip && key === hash) {
        ReactDOM.render(Apps, document.getElementById("root"));
    } else {
        ReactDOM.render(
            <IonPage>
                <IonContent color='dark'>
                    <div style={{ height: '20%' }}></div>
                    <IonRow>
                        <IonCol offset-md='3.5' size-md='5'>
                            <IonCard color='light' class='ion-padding'>
                                {contactUs}
                                <h4>Click Enter to run app.</h4>
                                <IonButton
                                    color='dark'
                                    onClick={() => {
                                        if (!localStorage.getItem("expiredemoin")) {
                                            localStorage.setItem("expiredemoin", btoa(45));
                                        }
                                        window.location.reload();
                                    }}>Enter</IonButton>
                                <h1> </h1>
                                <IonButton color='dark' onClick={() => {
                                    Lisenced();
                                    window.location.reload();
                                }}>Get Lisensed</IonButton>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonContent>

            </IonPage>,
            document.getElementById("root")
        );
    }

    if (isExpired()) {
        localStorage.removeItem("netsession");
        config && (config.expired = true)

        // localStorage.setItem('expiredemoin', expireDate);
    }

    // setTimeout(()=> {
    //   localStorage.clear()
    //   window.location.reload()
    // }, 1000 * 30);
};

export default Demo
